import { render, staticRenderFns } from "./UserRoleForm.vue?vue&type=template&id=3121f069&scoped=true"
import script from "./UserRoleForm.vue?vue&type=script&lang=js"
export * from "./UserRoleForm.vue?vue&type=script&lang=js"
import style0 from "./UserRoleForm.vue?vue&type=style&index=0&id=3121f069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3121f069",
  null
  
)

export default component.exports